export enum QuestionType {
  LongAnswer = -1,
  ShortAnswer,
  Dropdown,
  Checkboxes,
  Radio,
  LinearScale,
  Email,
  Chips,
  Screenshot,
  ShortText,
  DefaultAcknowledgeQuestion,
}
